import { useQuery } from '@apollo/client';
import { GET_USER_COUNT } from 'helpers/graphql/userCount';
import LoginButton from '../../Header/LoginButton';
import { useState } from 'react';

export default function BlogNameJoin() {
  const [open, setOpen] = useState(false);
  const { data } = useQuery(GET_USER_COUNT);
  const userCount = data?.userCount || 4000;

  return (
    <>
      <section className="tw-py-10 tw-bg-primary-100 sm:tw-py-16 lg:tw-py-24">
        <div className="tw-px-4 tw-mx-auto sm:tw-px-6 lg:tw-px-8 tw-max-w-7xl">
          <div className="tw-max-w-2xl tw-mx-auto tw-text-center">
            <div className="tw-flex tw-items-center tw-justify-center">
              <div className="tw-w-20 tw-h-20 -tw-mr-6 tw-overflow-hidden tw-border-solid tw-bg-gray-300 tw-rounded-full tw-border-primary-100">
                <img
                  className="tw-object-cover tw-w-full tw-h-full"
                  src="/avatar/noemilunastorta/large"
                  alt=""
                />
              </div>
              <div className="tw-relative tw-overflow-hidden tw-bg-gray-300 tw-border-8 tw-border-primary-100 tw-rounded-full tw-border-solid tw-w-28 tw-h-28">
                <img
                  className="tw-object-cover tw-w-full tw-h-full"
                  src="/avatar/julianhorack/large"
                  alt=""
                />
              </div>
              <div className="tw-w-20 tw-h-20 -tw-ml-6 tw-overflow-hidden tw-border-solid tw-bg-gray-300 tw-rounded-full tw-border-primary-100">
                <img
                  className="tw-object-cover tw-w-full tw-h-full"
                  src="/avatar/mibreit-photo/large"
                  alt=""
                />
              </div>
            </div>
            <h2 className="tw-text-3xl tw-font-bold tw-leading-tight tw-text-gray-900 sm:tw-text-4xl">
              Join{' '}
              <span className="tw-text-primary-600">
                {userCount.toLocaleString()}
              </span>{' '}
              other travel bloggers and start a travel blog with TravelFeed!
            </h2>
            <p className="tw-max-w-xl tw-mx-auto tw-mt-6 tw-mb-12 tw-text-xl tw-text-gray-600 md:tw-mt-10">
              TravelFeed takes the pain out of travel blogging.
            </p>

            <div
              className="tw-rounded tw-inline-flex tw-items-center tw-justify-center tw-px-10 tw-py-4 tw-text-base tw-font-semibold tw-text-white tw-transition-all tw-duration-200 tw-bg-primary-500 hover:tw-bg-primary-600 focus:tw-bg-primary-600 tw-cursor-pointer"
              role="button"
              onClick={() => setOpen(true)}
              tabIndex={0}
            >
              Start your travel blog
            </div>
          </div>
        </div>
      </section>
      {open && (
        <LoginButton
          open={open}
          hideButtons
          onClickClose={() => setOpen(false)}
        />
      )}
    </>
  );
}
